export const TYPE_OPTION_VR = 'vr';
export const TYPE_OPTION_MPR = 'mpr';
export const TYPE_OPTION_VOLUME = 'volume'; // is this needed?

export const TYPE_OPTION_VR_CORONAL_ANTERIOR = 'coronalAnterior';
export const TYPE_OPTION_VR_CORONAL_POSTERIOR = 'coronalPosterior';
export const TYPE_OPTION_VR_AXIAL_SUPERIOR = 'axialSuperior';
export const TYPE_OPTION_VR_AXIAL_INFERIOR = 'axialInferior';
export const TYPE_OPTION_VR_SAGITAL_DERECHA = 'sagitalDerecha';
export const TYPE_OPTION_VR_SAGITAL_IZQUIERDA = 'sagitalIzquierda';

export const TYPE_OPTION_CORONAL_ANTERIOR = 'coronalAnterior';
export const TYPE_OPTION_CORONAL_POSTERIOR = 'coronalPosterior';
export const TYPE_OPTION_AXIAL_SUPERIOR = 'axialSuperior';
export const TYPE_OPTION_AXIAL_INFERIOR = 'axialInferior';
export const TYPE_OPTION_SAGITAL_DERECHA = 'sagitalDerecha';
export const TYPE_OPTION_SAGITAL_IZQUIERDA = 'sagitalIzquierda';

export const vrDefault = {
  typeOption: TYPE_OPTION_VR,
  tempViewer: TYPE_OPTION_VR,
  enableHistogram: false,
  enableLightSliders: false,
  enableClippingSliders: false,
  paletteOptions: {
    width: 650,
    height: 170,
    bottom: 195,
    left: 5,
  },
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_CORONAL_ANTERIOR,
  },
  addEventsToDiv: true,
  viewColor: '#ed8123',
  orientationLetters: true,
  orientationCube: true,
  fitImage: true,
  enableRules: false,
  isMultiViewer: false,
};

export const coronalAnteriorVR = {
  ...vrDefault,
  typeOption: TYPE_OPTION_CORONAL_ANTERIOR,
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_CORONAL_ANTERIOR,
  },
};

export const coronalPosteriorVR = {
  ...vrDefault,
  typeOption: TYPE_OPTION_CORONAL_POSTERIOR,
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_CORONAL_POSTERIOR,
  },
};

export const axialSuperiorVR = {
  ...vrDefault,
  typeOption: TYPE_OPTION_AXIAL_SUPERIOR,
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_AXIAL_SUPERIOR,
  },
};

export const axialInferiorVR = {
  ...vrDefault,
  typeOption: TYPE_OPTION_AXIAL_INFERIOR,
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_AXIAL_INFERIOR,
  },
};

export const sagitalDerechaVR = {
  ...vrDefault,
  typeOption: TYPE_OPTION_SAGITAL_DERECHA,
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_SAGITAL_DERECHA,
  },
};

export const sagitalIzquierdaVR = {
  ...vrDefault,
  typeOption: TYPE_OPTION_SAGITAL_IZQUIERDA,
  viewType: {
    type: TYPE_OPTION_VR,
    camera: TYPE_OPTION_SAGITAL_IZQUIERDA,
  },
};

export const mprDefault = {
  tempViewer: TYPE_OPTION_MPR,
  // text: WARNING -> is overridden in View.js
  addEventsToDiv: true,
  axisViewColor: '#ff0000',
  orientationLetters: false,
  fitImage: true,
  enableRules: false,
  isMultiViewer: false,
  ruleOptions: {
    fixed: false, // switcher
    size: 30,
    color: '#FFFFFF',
    markSize: 5,
    marginBorder: 15,
    verticalRule: true,
    horizontalrule: true,
    countBigMarkLine: 12,
  },
  enableGrid: false,
  gridOptions: {
    color: '#FFFFFF',
    block: true,
    distance: 10,
  },
  typeOption: TYPE_OPTION_CORONAL_ANTERIOR,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_CORONAL_ANTERIOR,
  },
  viewColor: '#56ef63',
  isSync: true,
  crossReferenceLinesActive: true,
  localizerLinesActive: false,
  axisIntersectionLinesEnabled: true,
  showLocatorViewer: false,
  sliderVisible: false,
};

export const coronalAnterior = {
  ...mprDefault,
  typeOption: TYPE_OPTION_CORONAL_ANTERIOR,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_CORONAL_ANTERIOR,
  },
  viewColor: '#56ef63',
  axisViewColor: '#ff0000',
};

export const coronalPosterior = {
  ...mprDefault,
  typeOption: TYPE_OPTION_CORONAL_POSTERIOR,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_CORONAL_POSTERIOR,
  },
  viewColor: '#37c9f2',
  axisViewColor: '#00ff00',
};

export const axialInferior = {
  ...mprDefault,
  typeOption: TYPE_OPTION_AXIAL_INFERIOR,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_AXIAL_INFERIOR,
  },
  viewColor: '#ce3737',
  axisViewColor: '#00ff00',
};

export const axialSuperior = {
  ...mprDefault,
  typeOption: TYPE_OPTION_AXIAL_SUPERIOR,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_AXIAL_SUPERIOR,
  },
  viewColor: '#ce3737',
  axisViewColor: '#00ff00',
};

export const sagitalDerecha = {
  ...mprDefault,
  typeOption: TYPE_OPTION_SAGITAL_DERECHA,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_SAGITAL_DERECHA,
  },
  viewColor: '#37c9f2',
  axisViewColor: '#0000ff',
};

export const sagitalIzquierda = {
  ...mprDefault,
  typeOption: TYPE_OPTION_SAGITAL_IZQUIERDA,
  viewType: {
    type: TYPE_OPTION_MPR,
    camera: TYPE_OPTION_SAGITAL_IZQUIERDA,
  },
  viewColor: '#37c9f2',
  axisViewColor: '#0000ff',
};

export const listOptions3D = [vrDefault, mprDefault];

export const LAYOUT_VR_CONFIG = [coronalAnterior, '', '', axialSuperior, '', '', sagitalDerecha, '', coronalAnteriorVR];

export const LAYOUT_MPR_CONFIG = [sagitalIzquierda, '', '', coronalAnterior, '', axialInferior];

export const cameras = [TYPE_OPTION_CORONAL_ANTERIOR, TYPE_OPTION_CORONAL_POSTERIOR, TYPE_OPTION_AXIAL_SUPERIOR, TYPE_OPTION_AXIAL_INFERIOR, TYPE_OPTION_SAGITAL_DERECHA, TYPE_OPTION_SAGITAL_IZQUIERDA];

export const cameraOptionsMpr = [coronalAnterior, coronalPosterior, axialSuperior, axialInferior, sagitalDerecha, sagitalIzquierda];

export const cameraOptionsVr = [coronalAnteriorVR, coronalPosteriorVR, axialSuperiorVR, axialInferiorVR, sagitalDerechaVR, sagitalIzquierdaVR];
